var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[(_vm.config.setForm.isprocess)?_c('el-steps',{attrs:{"active":_vm.active,"align-center":""}},_vm._l((_vm.menuData),function(item){return _c('el-step',{key:item.title,attrs:{"title":_vm.language == 'cn' ? item.title : item.en_title}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }